import React from 'react';
import { Form } from 'react-final-form';
import { ButtonV2 } from '@zola/zola-ui';
// types and utils
import _pickBy from 'lodash/pickBy';
import _identity from 'lodash/identity';
import type { UpdateWeddingRequest, WWeddingView } from '@zola/svc-web-api-ts-client';
import * as Validations from 'components/common/form/commonValidations';
import { mapWeddingStateToForm, mapFormToRequest, fillFormValues } from './util/mappers';
// form components
import { FormInput } from '../../../../components/common/form/FinalFormV2Elements';
import FieldSetPersonInfo from './components/FieldSetPersonInfo';
import FieldSetDate from './components/FieldSetDate';
import FieldLocation from './components/FieldLocation';
// styles
import styles from './WeddingDetails.module.less';

type WeddingDetailsProps = {
  onSubmit: (req: UpdateWeddingRequest) => void;
  weddingState: WWeddingView;
  registryIsPublic: boolean;
};

const WeddingDetails: React.FC<WeddingDetailsProps> = ({
  onSubmit,
  weddingState,
  registryIsPublic,
}) => {
  const mappedFormValues = mapWeddingStateToForm(weddingState);
  // include other values needed for validation
  const initialFormInputValues = Object.assign(mappedFormValues, {
    currentlySelectedDate: weddingState.wedding_date,
    registryIsPublic,
  });
  // because react-final-form transforms the values of empty fields to undefined
  // in order for pristine meta value to properly reflect whether form has been changed
  // filter out falsy values
  const filteredFormInputValues = _pickBy(initialFormInputValues, _identity);

  return (
    <div className={styles.weddingDetailsContainer}>
      <Form
        initialValues={filteredFormInputValues}
        onSubmit={(v): void => {
          const filledFormValues = fillFormValues(v, initialFormInputValues);
          const req = mapFormToRequest(filledFormValues, weddingState);
          onSubmit(req);
        }}
        render={({ handleSubmit, submitting, pristine, valid, form, values }): React.ReactNode => (
          <form onSubmit={handleSubmit}>
            <div className={styles.nameFieldSetContainer}>
              <FieldSetPersonInfo nameKey="owner" label="Your Name" />
            </div>
            <div className={styles.nameFieldSetContainer}>
              <FieldSetPersonInfo nameKey="partner" label="Your Partner's Name" />
            </div>
            <div className={styles.dateFieldSetContainer}>
              <FieldSetDate formMutators={form} formValues={values} />
            </div>
            <div className={styles.guestFieldSpacing}>
              <FormInput
                className={styles.narrowInputField}
                label="Guest Count"
                name="guest_count"
                validate={[Validations.NUMBER, Validations.MAX_LENGTH_5]}
              />
            </div>
            <div className={styles.tallerFieldSpacing}>
              <FieldLocation formMutators={form} />
            </div>
            <div className={styles.tallerFieldSpacing}>
              <FormInput
                className={styles.widerInputField}
                label="Hashtag"
                name="hashtag"
                addOn="hashtag"
                maxChars={40}
              />
            </div>
            <ButtonV2
              type="submit"
              onClick={handleSubmit}
              disabled={!valid || pristine || submitting}
            >
              Save Changes
            </ButtonV2>
          </form>
        )}
      />
    </div>
  );
};

export default WeddingDetails;



// WEBPACK FOOTER //
// ./src/pages/settings/wedding/WeddingDetails/WeddingDetails.tsx